<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MaintainReport/QISummary'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-4"> 
                <div class="form-group ">
                  <label class="label">ปี:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reYearStart'"
                    :name="'reYearStart'"
                    :select2-options="reYearOptions"
                    v-model="reYearStart"
                    ref="reYearStart"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first">
              <label class="label">สรุปข้อมูลงานช่างซ่อมบำรุง:</label>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover table-checkable">
                      <thead>
                        <tr>
                          <th class="text-center" width="6%"><strong>Y{{reYearStart}}</strong></th>
                          <th class="text-center"><strong>Fix Cost</strong></th>
                          <th class="text-center"><strong>Variable Cost</strong></th>
                          <th class="text-center"><strong>Total Maintenance Cost</strong></th>
                          <th class="text-center"><strong>Repair Cost</strong></th>
                          <th class="text-center"><strong>Cost Reduction</strong></th>
                          <th class="text-center"><strong>Percentage</strong></th>
                          <th class="text-center"><strong>% Uplift</strong></th>
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(month, index) in months" :key="index">
                          <td class="text-center">
                            <span class="form-control-plaintext">
                              <strong>{{ month }}</strong>
                            </span>
                          </td>
                          <td class="text-right">
                            <input
                              v-model.number="tableData[index].fixCost"
                              type="number"
                              step="0.01"
                              class="form-control text-right"
                              placeholder="กรอก Fix Cost"
                            />
                          </td>
                          <td class="text-right">
                            <span class="form-control-plaintext">
                              {{ tableData[index].variableCost }}
                            </span>
                          </td>
                          <td class="text-right">
                            <span class="form-control-plaintext">
                              {{ calculateTotalCost(tableData[index].fixCost, tableData[index].variableCost) }}
                            </span>
                          </td>
                          <td class="text-right">
                            <span class="form-control-plaintext">
                              {{ tableData[index].repairCost }}
                            </span>
                          </td>
                          <td class="text-right">
                            <span class="form-control-plaintext">
                              {{ calculateCostReduction(calculateTotalCost(tableData[index].fixCost, tableData[index].variableCost), tableData[index].repairCost) }}
                            </span>
                          </td>
                          <td class="text-right">
                            <span class="form-control-plaintext">
                              {{ calculatePercentage(calculateCostReduction(calculateTotalCost(tableData[index].fixCost, tableData[index].variableCost), tableData[index].repairCost), tableData[index].repairCost) }}
                            </span>
                          </td>
                          <td class="text-right">
                            <input
                              v-model.number="tableData[index].uplift"
                              type="number"
                              step="0.01"
                              class="form-control text-right"
                              placeholder="กรอก % Uplift"
                            />
                          </td>
                          <td class="text-center">
                            <span class="form-control-plaintext d-flex justify-content-center">
                              <button type="button" class="btn btn-primary btn-sm btn-brand p-1 mr-1" @click="Recalculate(index)">
                                คำนวณใหม่
                              </button>
                              <button type="button" class="btn btn-success btn-sm btn-brand p-1" @click="saveSummary(index)">
                                <i class="fa fa-save"></i>บันทึก
                              </button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td class="text-center"><strong>รวม</strong></td>
                          <td class="text-right"><strong>{{ sumColumn('fixCost') }}</strong></td>
                          <td class="text-right"><strong>{{ sumColumn('variableCost') }}</strong></td>
                          <td class="text-right"><strong>{{ sumTotalCost() }}</strong></td>
                          <td class="text-right"><strong>{{ sumColumn('repairCost') }}</strong></td>
                          <td class="text-right"><strong>{{ sumCostReduction() }}</strong></td>
                          <td class="text-right"><strong>{{ sumPercentage() }}</strong></td>
                          <td class="text-right"><strong>{{ sumColumnUplift() }}</strong></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div
                class="col-xl-6"
                v-if="this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN'])"
              >
                <button
                  class="btn btn-outline-primary"
                  @click="exportExcel"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "../../Shared/Select2";
import axios from "axios";
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    return {
      reYearStart: new Date().getFullYear(),
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          { id: new Date().getFullYear(), text: new Date().getFullYear() },
          { id: new Date().getFullYear() - 1, text: new Date().getFullYear() - 1 },
          { id: new Date().getFullYear() - 2, text: new Date().getFullYear() - 2 },
        ],
      },
      months: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      tableData: Array(12).fill().map(() => ({
        fixCost: null,
        variableCost: 0,
        repairCost: 0,
        uplift: null
      })),
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      this.reYearStart = new Date().getFullYear();
      $(`#reYearStart`).val(this.reYearStart).trigger("change");
    },
    formSubmit: function(e) {
      e.preventDefault();
    },
    exportExcel: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/ReportSummary",
        responseType: "arraybuffer",
        data: {
          YearStart: self.reYearStart,
          IsExport: true,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    getSummaryData() {
      let self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });
      axios({
        method: "post",
        url: "/Api/QIJobs/CalReportSummary",
        data: {
          YearStart: self.reYearStart,
          IsRecal: false,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          const apiData = response.data;

          const months = Array.from({ length: 12 }, (_, i) => ({
            month: i + 1,
            fixCost: null,
            variableCost: 0,
            repairCost: 0,
            uplift: null
          }));
          apiData.forEach(item => {
            const monthIndex = item.month - 1;
            months[monthIndex].fixCost += item.fixCost || 0;
            months[monthIndex].variableCost += item.variableCost || 0;
            months[monthIndex].repairCost += item.repairCost || 0;
            months[monthIndex].uplift += item.uplift || 0;
          });
          self.tableData = months.map(month => ({
            month: month.month,
            fixCost: month.fixCost || null,
            variableCost: month.variableCost || 0,
            repairCost: month.repairCost || 0,
            uplift: month.uplift || null,
          }));
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    async Recalculate(index) {
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/CalReportSummary",
        data: {
          YearStart: self.reYearStart,
          monthStart: self.tableData[index].month,
          IsRecal: true,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          const data = response.data;
          if (data.length > 0) {
            const result = data[0];
            self.$set(self.tableData, index, {
              month: self.tableData[index].month,
              fixCost: self.tableData[index].fixCost || null,
              uplift: self.tableData[index].uplift || null,
              variableCost: result.variableCost || 0,
              repairCost: result.repairCost || 0 
            });
          }
          else {
            Swal.fire("ไม่สามารถคำนวณใหม่ได้ เนื่องจากไม่มีข้อมูล", "", "warning");
          }
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    async saveSummary(rowIndex) {
      let self = this;
      const summaryData = this.tableData[rowIndex];

      if (summaryData.fixCost === undefined || summaryData.fixCost == null || summaryData.fixCost == ""){
        Swal.fire("","กรุณาระบุ Fix Cost","warning");
        return false;
      }

      if (summaryData.uplift=== undefined || summaryData.uplift == null || summaryData.uplift == ""){
        Swal.fire("","กรุณาระบุ % Uplift","warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      const dataToSave = {
        year: this.reYearStart,
        month: summaryData.month,
        fixCost: summaryData.fixCost,
        variableCost: summaryData.variableCost,
        totalMaintainCost: parseFloat(this.calculateTotalCost(summaryData.fixCost, summaryData.variableCost)),
        repairCost: summaryData.repairCost,
        costReduction: parseFloat(
          this.calculateCostReduction(this.calculateTotalCost(summaryData.fixCost, summaryData.variableCost), summaryData.repairCost)
        ),
        percentage: parseFloat(
          this.calculatePercentage(
            this.calculateCostReduction(this.calculateTotalCost(summaryData.fixCost, summaryData.variableCost), summaryData.repairCost),
            summaryData.repairCost
          )
        ),
        uplift: summaryData.uplift
      };

      axios({
        method: "post",
        url: "/Api/QIJobs/SaveSummary",
        data: dataToSave,
      })
      .then(function(response) {
        if (response.data.status) {
          Swal.fire("บันทึกข้อมูลสำเร็จ", "", "success");
        } else {
          Swal.fire("ไม่สามารถบันทึกข้อมูลได้", "", "error");
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
        self.getSummaryData();
      });
    },
    calculateTotalCost(fixCost, variableCost) {
      return ((fixCost || 0) + (variableCost || 0)).toFixed(2);
    },
    calculateCostReduction(totalCost, repairCost) {
      return ((repairCost || 0) - (totalCost || 0)).toFixed(2);
    },
    calculatePercentage(costReduction, repairCost) {
      return repairCost !== 0 ? ((costReduction / repairCost) * 100).toFixed(2) : 0;
    },
    sumColumn(column) {
      const sum = this.tableData.reduce((acc, item) => acc + (parseFloat(item[column]) || 0), 0);
      return sum.toFixed(2);
    },
    sumTotalCost() {
      const sum = this.tableData.reduce((acc, item) => acc + parseFloat(this.calculateTotalCost(item.fixCost, item.variableCost)), 0);
      return sum.toFixed(2);
    },
    sumCostReduction() {
      const sum = this.tableData.reduce((acc, item) => acc + parseFloat(this.calculateCostReduction(this.calculateTotalCost(item.fixCost, item.variableCost), item.repairCost)), 0);
      return sum.toFixed(2);
    },
    sumPercentage() {
      const totalCostReduction = this.sumCostReduction();
      const totalServiceCost = this.sumColumn('repairCost');
      return totalServiceCost !== 0 ? ((totalCostReduction / totalServiceCost) * 100).toFixed(1) : 0;
    },
    sumColumnUplift() {
      const validMonths = this.tableData.filter(item => item.uplift !== null && item.uplift !== undefined && item.uplift !== '');
      const sum = validMonths.reduce((acc, item) => acc + (parseFloat(item.uplift) || 0), 0);
      const avgUplift = validMonths.length > 0 ? (sum / validMonths.length).toFixed(1) : 0;
      return avgUplift;
    },
  },
  async mounted() {
    this.getSummaryData();
  },
  watch: {
    reYearStart(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getSummaryData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// App/Components/QIJob/ReportQISummary.vue